import { makeVar } from '@apollo/client'

export const openedToolTipIdVar = makeVar<string>('')
